import React from "react";

export default function AppFormikInputInline(props) {
    const {
        formik,
        stFormClass,
        inputType,
        labelName,
        isRequired,
        placeholder,
        formikFieldName,
        hasLimit,
        chractersLimit,
        noErrorMessage,
        disabled,

        currenceyIcon
    } = props;

    return (
        <div
            className={`st-form ${stFormClass || ""} ${
                formik.touched[formikFieldName] &&
                formik.errors[formikFieldName]
                    ? "has-msg msg-error"
                    : ""
            } ${hasLimit ? "input-container-with-text-length has-limit" : ""}`}
        >
            {labelName ? (
                <label>
                    {labelName}
                    {isRequired && (
                        <span className="required ms-1 st-fs-12">
                            (required)
                        </span>
                    )}
                </label>
            ) : null}
            <input
                type={inputType ?? "text"}
                className="form-control"
                placeholder={placeholder}
                id={formikFieldName}
                {...formik.getFieldProps(formikFieldName)}
                disabled={disabled}
            />
            {
                // currenceyIcon
                currenceyIcon ? (
                    <div className="currencey">
                        {currenceyIcon}
                    </div>
                ) : null
            }
            {
                /* form message */
                !noErrorMessage
                    ? formik.touched[formikFieldName] &&
                      formik.errors[formikFieldName] && (
                          <div className="st-form-msg position-absolute">
                              <p className="st-fs-12">
                                  {formik.errors[formikFieldName]}
                              </p>
                          </div>
                      )
                    : null
            }
            {
                /* text length */
                hasLimit ? (
                    <div className="text-length">
                        <p className="">
                            {`${
                                formik.getFieldProps(formikFieldName)?.value
                                    ?.length
                            } of ${chractersLimit ?? 0} characters used`}
                        </p>
                    </div>
                ) : null
            }
        </div>
    );
}
